import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import TEXT from "../../../../utils/globalText";
import { globalTextFormat } from "../../../../utils/globalTextFormat";
import ICONS from "../../../../assets/Icons";

const OwnerAccountBulkUploadStatementSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [sucessData, setSucessData] = useState([]);

  useEffect(() => {
    const data = sessionStorage.getItem("uploadStatementData");
    setSucessData(JSON.parse(data));
  }, []);

  useEffect(() => {
    dispatch(disableSwitcher());

    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(enableSwitcher());
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch, id]);

  const uploadBankStatement = () => {
    navigate("/owner_account_dashboard/upload_bulk_bank_statement");
    try {
      sessionStorage.removeItem("recreate_ben");
    } catch (error) {
      console.error(error)
    }
  };

  const dashboardHandler = () => {
    navigate("/owner_account_dashboard", { replace: true });
  };

  const buttonRows = [
    [
      {
        btnText: globalTextFormat(TEXT?.UPLOAD_BANK_STATEMENT?.toLowerCase(),[0]),
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: uploadBankStatement,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: TEXT?.GO_TO_DASHBOARD,
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: TEXT?.BLACK,
      },
    ],
  ];

  return (
    <>
      <div className="mx-auto">
        <StatusContainer
          isLoading={false}
          status={TEXT?.SUCCESS}
          hoverOption={TEXT?.WHITE}
          title={TEXT?.STATEMENT_PROCESSING_NOTE}
          subtitle={TEXT?.DATA_UPLOAD_STATEMENT}
          buttonRows={buttonRows}
        >
          <TabsWeapperSection title={TEXT?.UPLOAD_DETAILS}>
            <>
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: formatAccountNumber(sucessData?.account_no),
                    leftSubTitle: globalTextFormat(TEXT?.BANK_ACCOUNT_NUMBER,[0,1,2])
                  },
                ]}
              />

              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: sucessData?.iFSC_Code,
                    leftSubTitle: TEXT?.IFSC_CODE,
                    ifsc: sucessData?.iFSC_Code,
                  },
                ]}
              />

              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle:
                      sucessData?.uploaded_file_data?.metadata?.filename,

                    leftSubTitle: TEXT?.FILE_NAME,
                  },
                ]}
              />
            </>
          </TabsWeapperSection>
        </StatusContainer>
      </div>
    </>
  );
};

export default OwnerAccountBulkUploadStatementSuccess;
